import { isCustomFieldValueEmpty } from '../isCustomFieldValueEmpty';
/** Return the custom fields that have empty values. */
export function getEmptyCustomFields({ customFields, onlyRequired = false, }) {
    return customFields.filter(({ attribute: { is_required }, value }) => (!onlyRequired || is_required) && isCustomFieldValueEmpty(value));
}
